/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class PaymentMethodDto extends JSONable {
  paymentMethodType: string | null = null;
  subscriptionTypeUuid: string | null = null;
  uuid: string | null = null;
  valid: string | null = null;
  redirectAfterPaymentUrl: string | null = null;
}
